module.exports = __webpack_public_path__ + "img/green_123.522256b1.png";